import {
  fetchCompletedVisits,
  fetchOpenVisits,
} from '../../salon-admin/utils/checkinQueueApi';
import { deskServiceShortLabel, partitionVisitServices } from '../../admin-shared/checkinServiceDesk';

/** Guest has at least one service line started or completed (not check-in only). */
export function hasStartedService(checkin) {
  const { inProgress, completed } = partitionVisitServices(checkin?.selected_services);
  return inProgress.length > 0 || completed.length > 0;
}

export function guestHasName(checkin) {
  return Boolean(String(checkin?.customer_name || '').trim());
}

export function reelGuestSubtitle(checkin) {
  const label = deskServiceShortLabel(checkin?.selected_services);
  if (label) return label;
  const { inProgress, completed } = partitionVisitServices(checkin?.selected_services);
  if (inProgress.length) return 'Service in progress';
  if (completed.length) return 'Service completed';
  return '';
}

/** Today's visits eligible for transformation reels (service started on desk). */
export async function fetchReelEligibleGuests() {
  const [open, done] = await Promise.all([fetchOpenVisits(), fetchCompletedVisits()]);
  const byId = new Map();
  for (const row of [...(open || []), ...(done || [])]) {
    if (!row?.id || !hasStartedService(row) || !guestHasName(row)) continue;
    byId.set(String(row.id), row);
  }
  return [...byId.values()].sort((a, b) =>
    String(b.updated_at || b.started_at || b.id || '').localeCompare(
      String(a.updated_at || a.started_at || a.id || ''),
    ),
  );
}
